<template>
<b-container fluid  class="bv-example-row">

  <b-row>
  <b-col class="contenido-login">
    <div class="logos-container">
      <b-img class="logo" :src="logo"></b-img>
      <b-img class="logo-sura" :src="logosura"></b-img>
    </div>
    <b-card  class="mb-2">
    <b-card-title>
        <div class="ingreso-al-sistema-prm poppins-semi-bold-mine-shaft-20px">{{ ingresoAlSistemaPrm }}</div>
    </b-card-title>
        <b-card-text class="carttex">
         <b-row class="campoconte">
            <b-col 	cols="7">
            <div class="correo-electrnico poppins-semi-bold-tuatara-14px">{{email}}</div>
            </b-col>
            <b-col cols="5" class="reco">
                <input class="form-check-input" type="checkbox" v-model="mini"  name="checkbox-1" >
            <div class="recordar poppins-normal-tuatara-14px">{{Recordar}}</div>
            </b-col>
         </b-row>
          <b-form-input type="email" trim v-model="username" class="campo tm " name="username" @focus="placeholderr()" @blur="placeholderre()"  :placeholder="placeholder" :style=" (this.username == ''||this.condicionEmail == true && this.username != '') ? 'border: 2px solid red !important' : 'border: 2px solid #ced4da ' " ></b-form-input>
               <div v-if="this.username == '' "  class="ingrese-un-correo-electrnico poppins-normal-alizarin-crimson-12px">{{ ingreseUnCorreoElectrnico }}</div>
                 <div v-if="this.condicionEmail == true && this.username != '' " class="ingrese-un-correo-electrnico poppins-normal-alizarin-crimson-12px">{{ errorCorreo }}</div>
          <b-row>
            <b-col>
            <div class="correo-electrnico poppins-semi-bold-tuatara-14px">{{passworde}}</div>  
            </b-col>
         </b-row>
          <b-input-group >
            <b-input v-model="password" trim  :type="passwordd" class="campo tm emaill "  @focus="placeholderdd()" @blur="placeholderdde()" :placeholder="placeholderd" v-bind:style= "[this.password == ''  ? {'border-top':' 2px solid red !important','border-left':' 2px solid red !important' ,'border-bottom':' 2px solid red !important' }:{'border': ''}]"></b-input>
             <b-input-group-append class="campoa eye" >
                <b-input-group-text class="input-group-text-login" v-bind:style= "[this.password == ''  ? {'border-top':' 2px solid red !important','border-right':' 2px solid red !important' ,'border-bottom':' 2px solid red !important' }:{'border': ''}]" @click="visualizarpass()">
                    <b-icon class="eyes" v-if="passwordd == 'password' " icon="eye" />
                     <b-icon class="eyes" v-if="passwordd == 'text' " icon="eye-slash" />
                </b-input-group-text>
             </b-input-group-append>
        </b-input-group>
          <div v-if="this.password == '' " class="ingrese-un-correo-electrnico addi poppins-normal-alizarin-crimson-12px">{{ ingreseUnaContrasea }}</div>
        </b-card-text>
        <div @click="ingreso()">
    
         <b-button block class="boton-ingreso"  ><label  v-if="this.load == false || this.notifi == true || this.activo == true ||this.isPopup== true || this.bloqueo == true " class="ingresar poppins-semi-bold-white-14px">Ingresar</label>
            <div v-if="this.notifi == false   &&  this.load == true  && this.isPopup== false  && this.activo== false && this.bloqueo == false"><b-spinner small></b-spinner><span class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span></div></b-button></div>
            <b-spinner v-if="this.loadin == true" class="sspiner"></b-spinner>
            <div v-if="this.notifi == true && this.loadin==false " class="ingrese-una-contraseas poppins-semi-bold-white-14px">{{ datosincorrectos }}</div>
            <div v-if="this.activo == true && this.loadin==false" class="ingrese-una-contraseasi poppins-normal-white-12px">{{ inactivo }}</div>
            <!-- <div class="ingrese-una-contraseasi poppins-normal-white-12px">{{ proceso }}</div> -->
            
          <div class="rectngulo-1344-1"></div>
         <b-row>
            <b-col> 
                <div  @click="olvidoLaContrasena()" class="recuperar-contrasea-1 poppins-semi-bold-blue-violet-14px">Recuperar contraseña</div>
            </b-col>
        </b-row>

        <!-- Enlace para auto-registro -->
        <div class="text-center mt-3">
          <span style="font-size:0.8rem; color:#555;">¿Eres una institución y aún no tienes cuenta?</span><br>
          <b-link class="registrarse-link" @click="$router.push('/registro-institucion')">
            Regístrate aquí
          </b-link>
        </div>

        <div class="modal">
            <b-modal
              centered
              hide-footer
              no-close-on-backdrop
              no-close-on-esc
              hide-header
              v-model="isPopup"
              title="Recuperar contraseña"
            >
             <ModalGeneral />

            </b-modal>
            <b-modal
              centered
              hide-footer
              no-close-on-backdrop
              no-close-on-esc
              hide-header
              v-model="bloqueo"
              title="Bloqueo por intentos"
            >
             <ModalUsuario/>

            </b-modal>
        </div>
    </b-card>
  </b-col>
    <b-col class="colimg"><b-img class="img" :src="cielumProps"></b-img></b-col>
  </b-row>
  
  <!-- Versión del Software -->
  <div class="login-version">
    <small>Oxígeno HelpHarma v{{ appVersion }}</small>
  </div>
  
</b-container>
</template>

<script>
import { RepositoryFactory } from "../repositories/RepositoryFactory";
import TokenService from "../repositories/TokenService";
import ModalGeneral from "../components/ModalGeneral.vue";
import ModalUsuario from "../components/ModalUsuario.vue";
import Repository from "../repositories/Repository";
import VueJwtDecode from "vue-jwt-decode";


const login = RepositoryFactory.get("login");
export default {
    name: "Login",
    components: {
         ModalGeneral,
         ModalUsuario,
    },

    props: [
        "logo",
        "logosura",
        "cielumProps",
        "ingresoAlSistemaPrm",
        "Recordar",
        "email",
        "passworde",
        "eye",
       "errorCorreo",
       "inactivo",
       "datosincorrectos",
       "ingreseUnCorreoElectrnico",
       "ingreseUnaContrasea",
       "proceso"
    ],
    data() {
        return {
            placeholder:"example@hotmail.com",
            placeholderd:"Ingrese su contraseña",
            username: "",
            password:null,
            usernamec: null,
            passwordc:null,
            passwordd: "password",
            notifi: false,
            condicionEmail:false,
            isPopup: false,
            message: String,
            activo:false,
            bloqueo:false,
            mini:false,
            auto:document.cookie.split(';'),
            load:false,
            loadin:false,
            appVersion: process.env.VUE_APP_VERSION || process.env.npm_package_version || '1.0.0',
        }
    },
    async created() {
        if(document.cookie == ''){
            this.username = null;
        }
    },
    methods: {
        async ingreso() {
            
            if(this.notifi == true || this.activo == true){
                this.loadin=true;
            }
           
            if (this.username == null || this.username == "" ) {
                this.username = '';
                
              
              
            } else if(this.password == null || this.password == ""){
                this.password = '';
            }else {
                var expReg = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
                var esValido = expReg.test(this.username);
                if (esValido == true ) {
                    this.condicionEmail= false;

                        var passReg = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
                    var passValido = passReg.test(this.password);
                    try {
                        this.load= true;
                        const response = await login.requestToken({"usuario": this.username, "password": this.password});
                        
                            const accessToken = response.payload.token;
                           
                            TokenService.setToken(accessToken);

                            TokenService.getToken()

                            const { userId, username, names, avatar } = VueJwtDecode.decode(accessToken);
                            const user = { id: userId, username, names, avatar };
                           
                            localStorage.setItem("user", JSON.stringify(user));
                            Repository.setHeaders();
                            if(this.mini == true){
                                document.cookie =  this.username,this.username, "/", "sitio.com", 1;
                        
                            }

                            this.$router.push("/inicio");
                    
                    } catch (error){
                    
                        this.load = false;
                        this.loadin=false;
                        if(!error.response) return;
                        if(error.response.data.error.code == "LA401"){
                            this.activo = false
                            this.notifi = false
                            this.isPopup= true
                        }
                        if(error.response.data.error.code== "MP401"){
                            this.notifi = true
                            if(error.response.data.error.code == "MP401"){
                                setTimeout(() => {
                                this.$router.go('/login');
                            }, 5000);
                            }
                            this.activo = false
                        }
                        if(error.response.data.error.code=="UI401"){
                            this.activo = true
                        }
                        if(error.response.data.error.code=="UB401"){
                            this.bloqueo = true
                        }
                        if(error.response.data.error.code=="UBI401"){
                            this.isPopup= true
                            this.activo = false
                            this.notifi = false
                            this.bloqueo = false
                        }
                        if(error.response.data.error.code=="SE400"){
                            this.isPopup= false
                            this.activo = false
                            this.notifi = true
                            this.bloqueo = false
                        }
                    
                    }
                }
                else{
                    this.condicionEmail= true;
                }
                
            }


        },
        
        placeholderr(){
            this.placeholder = "";
        },
        placeholderre(){
            this.placeholder = "example@hotmail.com";
        },
        placeholderdd(){
            this.placeholderd ="";
        },
        placeholderdde(){
            this.placeholderd ="Ingrese su contraseña";
        },
         visualizarpass(){
            if(this.passwordd == "password"){
                this.passwordd = "text"
            }else{
                this.passwordd = "password"
            }
        },
            async olvidoLaContrasena(){
            // this.isPopup = true;
            this.message= "Debes recuperar la contraseña"
            this.$router.push('/recuperarcontrasena');
        },

    }
};
</script>

<style>
.mb-2{
    background-color: var(--zircon);
  border-radius: 10px !important;
  padding: 0.8rem;
  max-width: 20rem;
  margin: auto;
  z-index: 1;
    border-color:transparent;
}
.registrarse-link {
  color: var(--blue-violet);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}
.registrarse-link:hover {
  color: var(--hover);
  text-decoration: underline;
}
.sr-only{
    margin-left: 4%;
    display: none;
}
.form-control:focus {
  box-shadow: none !important;
  border: 2px solid var(--blue-violet) !important;
}
.sspiner{
    margin-top: 13% !important;
}
.m-5{
    margin-top: 2% !important;
}
.eyes{
    color: var(--blue-violet);
    cursor:pointer;
}
.addi{
    margin-bottom: 9.5% !important;
}
.reco{
    padding-right: 7% !important;
}
.custom-control , .custom-checkbox{
display: flex !important;
   align-items: center !important;
}

.lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  margin: auto;
  width: 90vw;
}
.lines .line {
  position: absolute;
  width: 1px;
  height: 100%;
  top: 0;
  left: 50%;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
}
.lines .line::after {
  content: "";
  display: block;
  position: absolute;
  height: 15vh;
  width: 100%;
  top: -50%;
  left: 0;
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0)), color-stop(75%, #ffffff), to(#ffffff));
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 75%, #ffffff 100%);
  -webkit-animation: run 7s 0s infinite;
          animation: run 7s 0s infinite;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
  -webkit-animation-timing-function: cubic-bezier(0.4, 0.26, 0, 0.97);
          animation-timing-function: cubic-bezier(0.4, 0.26, 0, 0.97);
}
.lines .line:nth-child(1) {
  margin-left: -25%;
}
.lines .line:nth-child(1)::after {
  -webkit-animation-delay: 2s;
          animation-delay: 2s;
}
.lines .line:nth-child(3) {
  margin-left: 25%;
}
.lines .line:nth-child(3)::after {
  -webkit-animation-delay: 2.5s;
          animation-delay: 2.5s;
}

@-webkit-keyframes run {
  0% {
    top: -50%;
  }
  100% {
    top: 110%;
  }
}

@keyframes run {
  0% {
    top: -50%;
  }
  100% {
    top: 110%;
  }
}
/**/
.form-check-input:checked {
    background-color: var(--blue-violet) !important;
    border-color: var(--blue-violet) !important;
    
}
.activeClass{
    border:1px solid red;
}
.campoconte{
     display: flex;
   align-items: center;
}

.bv-example-row{
    background-color: var(--blue-violet);
     height: 100vh;
    /* margin:0;
    max-width: 100% !important;
    height: 753px !important; */
}
.img{
    max-height: 100%;
    height: 100%;
    position: absolute;
    right: 0;
    z-index: 0;
    
}
.contenido-login{
    text-align:center;
}
.logos-container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    margin: 0;
}
.logo{
    /* margin-top:8%;
    width: 40%; */
    margin: 0;
    width: 23%;
}
.logo-sura{
    margin: 0;
    width: 23%;
    max-width: 180px;
}
.ingreso-al-sistema-prm { 
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  margin-bottom:10%;
 
}
.card-body {
    padding: 1rem !important;
}

.correo-electrnico {
  left: 0;
  letter-spacing: 0;
  line-height: 14px;
  top: 0;
}
.recordar {
    letter-spacing: 0;
    line-height: 27px;
    float: right;
}
.carttex{
    text-align:left;
}
.campo{
    margin-top:4%;
    margin-bottom:10%; 
    font-size: small !important;
    border: 1px solid  var(--hawkes-blue) !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-bottom-left-radius: 10px !important;
}
.tm{
    height:49px;
}
.ingrese-un-correo-electrnico {
  letter-spacing: 0;
  line-height: 12px;
  text-align: right;
    margin-top: -8%;
    /* margin-bottom: 3.5%; */
}
.input-group-text-login {
       margin-top: 24%;
    margin-bottom: 12%;
    height: 63.4%;
    padding: 0.6rem 0.75rem;
    border: none !important;
    border-radius: 0 !important;
    background-color: white !important;
    border-bottom: 1px solid var(--hawkes-blue) !important;
    border-top: 1px solid var(--hawkes-blue) !important;
    border-right: 1px solid var(--hawkes-blue) !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}
.email{
  border: 1px solid var(--hawkes-blue) !important;
}
.emaill{
  border-bottom: 1px solid var(--hawkes-blue) !important;
    border-top: 1px solid var(--hawkes-blue) !important;
    border-left: 1px solid var(--hawkes-blue) !important; 
    border-right: 1px solid white !important;
    border-radius: 0 !important;
    border-top-left-radius: 10px !important;
    border-bottom-left-radius: 10px !important;
    
}
.boton-ingreso{
    width:100%;
    background-color: var(--blue-violet) !important;
    border-radius: 10px !important;
    height: 50px;
    border-color:transparent !important ;
    border-color:transparent !important ;
}
.boton-ingreso:hover{
    background: var(--hover) !important;
}
.recuperar-contrasea-1 {
  letter-spacing: 0;
  line-height: 14px;
  text-align: center;
  margin-top: 9%;
  margin-bottom:-2%;
  cursor:pointer;
}
.recuperar-contrasea-1:hover {
    color: var(--hover);
}
.rectngulo-1344-1 {
    background-color: var(--hawkes-blue);
    height: 1px;
    margin-top: 11%;
    margin-left: -11%;
    margin-right: -11%;
}
.form-check-input{
    border: 1px solid !important;
    border-color: var(--hawkes-blue) !important;
    border-radius: 4px !important;
    width: 20px !important;
    height: 19px !important;
    margin-right:3%;
    cursor: pointer;
}
.ingrese-una-contraseas {
  background-color: var(--alizarin-crimson);
    border-radius: 10px;
    display: flex;
    margin-top:3%;
    padding:5%;
}
.ingrese-una-contraseasi {
    background-color: var(--alizarin-crimson);
    border-radius: 10px;
    display: flex;
     margin-top:3%;
      padding:5%;
}
@media (max-width: 669px) {
.logo {
    margin: 6% 0 6%;
  width: 40%;
}
}
/* @media (max-width: 1922px) {

.mb-2 {
    margin-left: 33%;
}
.logo {
    margin-left: 8%;
}
.bv-example-row{
    height: 969px !important;
}
.img{
    max-height: 969px;
    height: 969px;
    
}
}
@media (max-width: 1540px) {

.bv-example-row{
    height: 753px !important;
}
.img{
    max-height: 753px;
    height: 753px;
    
}
.mb-2 {
    margin-left:25%;
    margin-top: 2%;
}
.logo {
    margin-left: 0%;
    width: 28%;
    margin-top: 5%
}
}
@media (max-width: 1370px) {
    .input-group-text {
        margin-top: 22% !important;
    height: 57.4% !important;
}
    .img {
    max-height: 651px ;
    height: 651px;
}
.logo {
    margin-top: 5% !important;
    margin-bottom: 2%;
    width: 27%;
}
.ingreso-al-sistema-prm {
    margin-bottom: 10%;
    margin-top: -4%;
}
.rectngulo-1344-1 {
    margin-top: 8%;
}
.recuperar-contrasea-1 {
    margin-top: 9%;
    margin-bottom: -8%;
}
.mb-2 {
    margin-top: 2%;
    margin-left: 24%;
    max-width: 21rem !important;
}
}
@media (max-width: 1280px) {

.bv-example-row{
    height: 609px !important;
}
.img{
    max-height: 609px;
    height: 609px;
    
}
.logo {
    margin-top: 6%;
    width: 30%;
    margin-left: 0%;
}
.mb-2 {
    margin-top: 5%;
    max-width: 19.5rem !important;
    padding: 2.5%;
}
.ingreso-al-sistema-prm {
    margin-bottom: 7%;
}
.campo {
    margin-top: 4%;
    margin-bottom: 3%;
    height: 45px;
   
}
.input-group-text {
    margin-top: 22% !important;
    margin-bottom: 10% !important;
    height: 64% !important;
    }
    
    .recuperar-contrasea-1 {
    margin-top: 4%;
}
.rectngulo-1344-1 {
    margin-top: 9%;
        margin-left: -13%;
    margin-right: -13%;
}
.ingrese-un-correo-electrnico {
    margin-top: -4%;
}
}
@media (max-width: 1100px) {

.bv-example-row{
    height: 507px !important;
}
.img{
    max-height: 507px;
    height: 507px;
    
}
.logo {
    margin-top: 3%;
    width: 39%;
    margin-left: 22%;
}
.mb-2 {
   max-width: 21rem !important;
       width: 100%;
       margin-top: 3%;
}
 .campo {
    height: 35px;
}   
.boton-ingreso {
    height: 40px;
}
.input-group-text {
    height: 61%;
    margin-top: 24%;
}
.campo {
    margin-bottom: 4%;
}
.ingreso-al-sistema-prm {
    margin-bottom: 5%;
}
.rectngulo-1344-1 {
    margin-top: 7%;
    margin-left: -12%;
    margin-right: -12%;
}

/* Estilos para la versión en login */
.login-version {
    position: fixed;
    bottom: 10px;
    right: 15px;
    z-index: 1000;
}

.login-version small {
    color: rgba(0, 0, 0, 0.5);
    font-size: 11px;
    font-weight: 400;
}

</style>

